module.exports = __webpack_public_path__ + "static/barn-demolition-single-2dbeeb38864ab2281d9914a273665f5c.jpg";